var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-3", attrs: { id: "nature-of-problem" } },
    [
      _c(
        "v-scroll-x-transition",
        [
          _c(
            "v-layout",
            {
              staticStyle: {
                overflow: "hidden",
                "-webkit-transition": "height 2s",
                transition: "height 2s"
              },
              style: _vm.height,
              attrs: { row: "", wrap: "", "pb-3": "" }
            },
            _vm._l(_vm.coSource, function(btn, index) {
              return _c(
                "v-flex",
                {
                  key: index,
                  staticClass: "pr-2",
                  attrs: { xs4: "", "text-xs-center": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "text-xs-center": "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: _vm.getActivedColor(btn.id),
                                fab: "",
                                large: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.handleAssignModel(btn.id)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "40px",
                                  "max-height": "40px"
                                },
                                attrs: { src: btn.picto }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "text-xs-center": "" } },
                        [
                          _c("strong", {
                            staticClass: "nature-problem--btn",
                            domProps: { textContent: _vm._s(btn.name) }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "px-2": "", "mx-2": "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                outline: "",
                block: "",
                small: "",
                flat: "",
                color: "primary"
              },
              on: { click: _vm.handleShowMore }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(_vm.dtShowMore ? "LBL_SHOW_LESS" : "LBL_SHOW_MORE")
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-194af80b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-194af80b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-nature-of-problem/template.html
// module id = null
// module chunks = 